<template>
  <div id="invoiceReport">
    <div class="wrapper">
      <el-card
        v-loading="loading"
        class="reportCard"
        shadow="always"
      >
        <header>
          <div class="contact">
            <div>GlobalCoachGroup.com</div>
            <div>accounting@GlobalCoachGroup.com</div>
          </div>
        </header>

        <table>
          <!-- Header bumper -->
          <thead>
            <tr>
              <td>
                <div class="spaceHeader"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <main v-if="report && flag">
                  <!-- Section - Title -->
                  <section>
                    <div class="title">
                      <div>INVOICE</div>
                      <div>For Global Coach Group Engagements</div>
                    </div>
                  </section>
                  <!-- Section - Pay to -->
                  <section>
                    <div class="emphasize">
                      TO:
                    </div>
                    <div class="emphasize">
                      ING Accounts Payable Team
                    </div>
                    <div>{{ report.payable_address }}</div>
                    <div>{{ report.country.name }}</div>
                    <div>{{ report.cost_centre }}</div>
                    <div>{{ report.payable_email }}</div>
                  </section>

                  <!-- Section - Pay from -->
                  <section>
                    <div class="emphasize">
                      FROM:
                    </div>
                    <div class="emphasize">
                      Global Coach Group (International) Limited
                    </div>
                    <div>17th Fl., 1702A, Glenealy Tower,</div>
                    <div>No. 1 Glenealy, Central, HONG KONG</div>
                    <!--<div>T. +852-3008-0614</div>-->
                    <div>
                      accounting@GlobalCoachGroup.com
                      <span class="rightText">GlobalCoachGroup.com</span>
                    </div>
                  </section>

                  <!-- Section - Invoice data -->
                  <section>
                    <div>
                      <span class="emphasize">Invoice Date: </span>
                      <span>{{ report.invoice_date }}</span>
                    </div>
                    <div>
                      <span class="emphasize">Invoice No: </span>
                      <span>{{ report.invoice_id }}</span>
                    </div>
                  </section>

                  <!-- Section - Dear accounts -->
                  <section>
                    <div class="emphasize">
                      Dear Accounts Payable,
                    </div>
                  </section>
                  <section>
                    <div>
                      Thank you for choosing Global Coach Group – Coaching Services.
                    </div>
                    <div>
                      We herewith provide you with our quotation and invoice
                      under the following terms and conditions:
                    </div>
                  </section>

                  <!-- Section - Order table -->
                  <PayableTable
                    :report="report"
                  />

                  <!-- Section - Reference -->
                  <section>
                    <div class="emphasize underLine">
                      REFERENCE DETAILS
                    </div>
                    <div class="emphasize">
                      Terms and Conditions:
                      HR Unite L&D FRAMEWORK AGREEMENT dated October 25<sup>th</sup> 2019
                    </div>
                  </section>
                  <section>
                    <div>
                      <span class="emphasize">
                        Purchase Order Number:
                      </span>
                      <span>{{ report.po_number ? report.po_number : 'N/A' }}</span>
                    </div>
                    <div>
                      <span class="emphasize">
                        ING Cost Centres:
                      </span>
                      <span>{{ report.cost_centre ? report.cost_centre : 'N/A' }}</span>
                    </div>
                    <div>
                      <span class="emphasize">
                        ING Cost Sort:
                      </span>
                      <span>{{ report.cost_sort ? report.cost_sort : 'N/A' }}</span>
                    </div>
                    <div>
                      <span class="emphasize">
                        Leader Name:
                      </span>
                      <span>{{ report.first_name }} {{ report.last_name }} (Contact Person)</span>
                    </div>
                    <div>
                      <span class="emphasize">
                        Corporate key:
                      </span>
                      <span>{{ report.corporate_key ? report.corporate_key : 'N/A' }}</span>
                    </div>
                    <div>
                      <span class="emphasize">
                        Line of Business:
                      </span>
                      <span>{{ report.business_line ? report.business_line : 'N/A' }}</span>
                    </div>
                    <div>
                      <span class="emphasize">
                        Line Manager Name:
                      </span>
                      <span>{{ report.l_manager_name ? report.l_manager_name : 'N/A' }}</span>
                    </div>
                  </section>
                  <section>
                    <div>
                      <span class="emphasize">
                        Period of Service Delivery:
                      </span>
                      <span>
                        Starting {{ report.invoice_date ? report.invoice_date : 'invoice date' }}
                        and to be completed within the next 7 months.
                      </span>
                    </div>
                    <div>
                      <span class="emphasize">
                        Applicable VAT:
                      </span>
                      <span>
                        VAT is applied based on ING invoice address country.
                        In case of The Netherlands, VAT ZERO %,
                        based on CRKBO conditions and regulations.
                      </span>
                    </div>
                  </section>

                  <!-- Section - Payment transfer -->
                  <section>
                    <div class="emphasize underLine">
                      PAYMENT TRANSFER
                    </div>
                    <div>
                      <span class="emphasize">
                        Payment due date:
                      </span>
                      <span>
                        {{ report.payment_due_date }}, i.e. Net 30 days after Invoice Date above.
                        Kindly ensure that the payment of the above amount is
                        received by us as per agreement terms below.
                      </span>
                    </div>
                  </section>

                  <!-- Section - Benificiary -->
                  <section>
                    <div class="emphasize">
                      Beneficiary
                    </div>
                    <div>Bank: HSBC Hong Kong</div>
                    <div>Bank address: 1 Queen’s Road, Central, Hong Kong</div>
                    <div>Swift Code: HSBCHKHHHKH</div>
                    <div>Payee Account No.: 499-793982-838</div>
                    <div>Payee: Global Coach Group (International) Limited</div>
                    <div>Payee Address: 17th Fl., 1702A, Glenealy Tower,</div>
                    <div>No. 1 Glenealy, Central, HONG KONG</div>
                    <div>Business Registration / Tax Reference No: 60347016</div>
                  </section>

                  <!-- Section - Division of charges -->
                  <section>
                    <div class="emphasize underLine">
                      Division of charges for banking fees:
                    </div>
                    <div>
                      Banking fees and any relevant taxes inside your country are
                      to be borne from your side.
                    </div>
                    <div>
                      Banking fees and any relevant taxes inside Hong Kong will be borne by us.
                    </div>
                  </section>

                  <!-- Section - Notice -->
                  <section>
                    <div class="emphasize underLine">
                      Notice to your bank:
                    </div>
                    <div>
                      Sender is responsible for payment of local bank charges
                      whereas beneficiary pays overseas bank charges (i.e. division of charges).
                    </div>
                  </section>

                  <!-- Section - Signiture -->
                  <section>
                    <div class="signatureWrap">
                      <img
                        class="signatureLogo"
                        src="@/assets/invoice/sign.png"
                        alt="signiture"
                      />
                      <div class="emphasize signatureText">
                        <div>Will Linssen</div>
                        <div>CEO</div>
                        <div>at Global Coach Group</div>
                      </div>
                    </div>
                  </section>
                </main>
                <main
                  v-else
                  class="noData"
                >
                  Failed to load
                </main>
              </td>
            </tr>
          </tbody>
          <!-- Footer bumper -->
          <tfoot>
            <tr>
              <td>
                <div class="spaceFooter"></div>
              </td>
            </tr>
          </tfoot>
        </table>

        <footer>
          <div class="logoHeader">
            <div class="logoWrap">
              <div class="circleCover"></div>
              <img
                class="logo"
                src="@/assets/logo/gcg_logo.png"
                alt="logo"
              />
            </div>

            <div class="footerInfo">
              <div>GlobalCoachGroup.com</div>
              <div>accounting@GlobalCoachGroup.com</div>
            </div>
          </div>
        </footer>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import dialog from '@/mixins/dialog';
import api from '@/api';
import PayableTable from './widgets/PayableTable.vue';

export default {
  components: {
    PayableTable,
  },

  mixins: [dialog],

  data() {
    return {
      loading: false,
      flag: false,
      report: null,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  mounted() {
    this.getReport();
  },

  methods: {
    async getReport() {
      try {
        this.loading = true;
        let response;

        if (this.$route.params.id) {
          response = await api.getLeaderInvoiceDocOA(this.$route.params.id);
        } else {
          response = await api.getLeaderInvoiceDoc();
        }

        this.flag = true;
        this.report = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  $mgcColor: #003865;

  #invoiceReport {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 812px;
    min-height: 100vh;
    background: #808080;
    line-height: 1.2rem;

    .wrapper {
      margin: 50px auto;

      .reportCard {
        border-radius: 0;
        margin: 0 auto;
        width: 800px;
        min-height: 300px;
        border: none;

        header {
          color: $mgcColor;
          margin: 0 0 20px;

          .contact {
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin: 0 0 20px;
            font-size: 14px;
          }
        }

        table {
          width: 100%;
        }

        main {
          section {
            font-size: 14px;
            padding: 10px 10px;
            white-space: pre-line;

            .title {
              text-align: center;
              font-weight: bold;
              font-size: 18px;
              color: $mgcColor;
            }

            &.noSide {
              padding: 10px 0;
            }

            .rightText {
              padding: 0 0 0 65px;
            }

            .emphasize {
              font-size: 15px;
              font-weight: bold;
            }

            .underLine {
              text-decoration: underline;
            }

            .signatureWrap {
              .signatureLogo {
                width: 180px;
                pointer-events: none;
              }

              .signatureText {
                margin: -30px 0 0;
                line-height: 16px;
              }
            }
          }

          &.noData {
            width: 100%;
            min-height: 150px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #c4c4c4;
            margin: 10px 0 0;
            font-style: italic;
          }
        }

        footer {
          .logoHeader {
            position: relative;
            box-sizing: border-box;
            font-weight: bold;
            font-size: 16px;
            margin: 55px -20px -20px -20px;
            padding: 25px 20px;
            background: $mgcColor;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .logoWrap {
              margin: 0 0 0;
              padding: 5px 0;

              /* .circleCover {
                position: absolute;
                width: 115px;
                height: 120px;
                border-radius: 100%;
                background-color: $mgcColor;
              } */

              .logo {
                pointer-events: none;
                position: relative;
                width: 110px;
              }
            }

            .footerInfo {
              color: white;
              text-align: right;
              font-weight: normal;
              margin: 0 0 0;
            }
          }
        }
      }
    }
  }

  @media print {
    #invoiceReport {
      justify-content: flex-start;
      background-color: white;

      .wrapper {
        .reportCard {
          box-shadow: none;

          header {
            position: fixed;
            width: calc(210mm - 40px);
            top: 0;
          }

          .spaceHeader {
            height: 35px;
          }

          .spaceFooter {
            height: 130px;
          }

          footer {
            position: fixed;
            width: calc(210mm - 40px);
            bottom: 15px;
            color-adjust: exact;
            -webkit-print-color-adjust: exact !important;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  @media print {
    #app,
    .dashGround {
      background: white !important;
    }
  }

  #invoiceReport {
    .reportCard {
      @page {
        size: a4;
      }
    }
  }
</style>
